"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _base = _interopRequireDefault(require("./base"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var StyledBase = (0, _styledComponents["default"])(_base["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  transform: rotate(30deg);\n"])));

var Pin = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Pin, _Component);

  var _super = _createSuper(Pin);

  function Pin() {
    (0, _classCallCheck2["default"])(this, Pin);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Pin, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(StyledBase, this.props, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M36 35.476V59a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V35.476C21.103 33.696 16 27.453 16 20c0-8.836 7.163-16 16-16s16 7.164 16 16c0 7.453-5.103 13.697-12 15.476z"
      }));
    }
  }]);
  return Pin;
}(_react.Component);

exports["default"] = Pin;
(0, _defineProperty2["default"])(Pin, "defaultProps", {
  size: 'tiny',
  predefinedClassName: 'data-ex-icons-pin'
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21tb24vaWNvbnMvcGluLnRzeCJdLCJuYW1lcyI6WyJTdHlsZWRCYXNlIiwiQmFzZSIsIlBpbiIsInByb3BzIiwiQ29tcG9uZW50Iiwic2l6ZSIsInByZWRlZmluZWRDbGFzc05hbWUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFHQTs7QUFDQTs7QUFDQTs7Ozs7Ozs7QUFFQSxJQUFNQSxVQUFVLEdBQUcsa0NBQU9DLGdCQUFQLENBQUgscUhBQWhCOztJQUlxQkMsRzs7Ozs7Ozs7Ozs7O1dBTW5CLGtCQUFTO0FBQ1AsMEJBQ0UsZ0NBQUMsVUFBRCxFQUFnQixLQUFLQyxLQUFyQixlQUNFO0FBQU0sUUFBQSxDQUFDLEVBQUM7QUFBUixRQURGLENBREY7QUFLRDs7O0VBWjhCQyxnQjs7O2lDQUFaRixHLGtCQUNHO0FBQ3BCRyxFQUFBQSxJQUFJLEVBQUUsTUFEYztBQUVwQkMsRUFBQUEsbUJBQW1CLEVBQUU7QUFGRCxDIiwic291cmNlc0NvbnRlbnQiOlsiLy8gU1BEWC1MaWNlbnNlLUlkZW50aWZpZXI6IE1JVFxuLy8gQ29weXJpZ2h0IGNvbnRyaWJ1dG9ycyB0byB0aGUga2VwbGVyLmdsIHByb2plY3RcblxuaW1wb3J0IFJlYWN0LCB7Q29tcG9uZW50fSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgQmFzZSwge0Jhc2VQcm9wc30gZnJvbSAnLi9iYXNlJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnc3R5bGVkLWNvbXBvbmVudHMnO1xuXG5jb25zdCBTdHlsZWRCYXNlID0gc3R5bGVkKEJhc2UpYFxuICB0cmFuc2Zvcm06IHJvdGF0ZSgzMGRlZyk7XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBQaW4gZXh0ZW5kcyBDb21wb25lbnQ8UGFydGlhbDxCYXNlUHJvcHM+PiB7XG4gIHN0YXRpYyBkZWZhdWx0UHJvcHMgPSB7XG4gICAgc2l6ZTogJ3RpbnknLFxuICAgIHByZWRlZmluZWRDbGFzc05hbWU6ICdkYXRhLWV4LWljb25zLXBpbidcbiAgfTtcblxuICByZW5kZXIoKSB7XG4gICAgcmV0dXJuIChcbiAgICAgIDxTdHlsZWRCYXNlIHsuLi50aGlzLnByb3BzfT5cbiAgICAgICAgPHBhdGggZD1cIk0zNiAzNS40NzZWNTlhMSAxIDAgMCAxLTEgMWgtNmExIDEgMCAwIDEtMS0xVjM1LjQ3NkMyMS4xMDMgMzMuNjk2IDE2IDI3LjQ1MyAxNiAyMGMwLTguODM2IDcuMTYzLTE2IDE2LTE2czE2IDcuMTY0IDE2IDE2YzAgNy40NTMtNS4xMDMgMTMuNjk3LTEyIDE1LjQ3NnpcIiAvPlxuICAgICAgPC9TdHlsZWRCYXNlPlxuICAgICk7XG4gIH1cbn1cbiJdfQ==